import { useEffect } from 'react';
import { useAnnouncementHeight } from '../../hooks/useAnnouncementHeight';

export const BodyMarginManager = () => {
  const height = useAnnouncementHeight((state) => state.height);

  useEffect(() => {
    document.body.style.paddingTop = `${height}px`;
    
    return () => {
      document.body.style.paddingTop = '0px';
    };
  }, [height]);

  return null;
}; 